<template></template>

<script>
export default {
  name: 'Logoff',
  mounted() {
    sessionStorage.clear()
    this.$store.dispatch('resetState')
    this.$router.push({ path: '/' })
  }
}
</script>
